import BannerBg from './banner-bg.png';
import ArrowIcons from './icons/arrow-back.png';
import Logo from './logo.svg';
import newLogo from './newLogo.png';
import DefaultUser from './default-user.svg';
import SortUp from './icons/sort-up.png';
import SortDown from './icons/sort-down.png';
import EditIcons from './icons/edit-icon.svg';
import LogOutIcons from './icons/logout-icon.png';
import EditFileIcons from './icons/edit-file.svg';
import CloseIcon from './icons/close.svg';
import EyeIcon from './icons/eye.png';
import smallEyeIcon from './icons/smallEye.png';
import CloseEyeIcon from './icons/closeEye.png';
import AttachFile from './icons/attchment.png';
import DownloadIcons from './icons/download.png';
import CopyPasteIcons from './icons/copy-paste.png';
import FaceBookIcons from './icons/facebook.svg';
import LinkeDinIcons from './icons/linkedin.svg';
import TwitterIcons from './icons/twitter.svg';
import InstagramIcons from './icons/instagram.svg';
import TrashIcons from './icons/trash.svg';
import SmallCloseIcon from './icons/smallClose.png';
import AddIcons from './icons/add.png';
import PinterestIcon from './icons/pinterest.png';
import RightArrowIcon from './icons/right-arrow.png';
import PlusIcons from './icons/plus.svg';
import whiteCross from './icons/white-cross.png';
import SadIcons from './icons/sad-icons.png';
import SaveIcon from './icons/save.png';
import CompanyDefaultUser from './icons/CompanyDefaultUser.svg';
import EmailIcon from './icons/email.png';
import PhoneIcon from './icons/phone.png';
import WhiteSortDown from './icons/WhiteSortDown.png';
import SortDownIcon from './icons/SortDown.png';
import InfoIcon from './icons/info.png';
import TelescopeIcon from './icons/telescope.svg';
import AlarmBellIcon from './icons/alarm-bell.png';
import ServiceAgreementIcon from './icons/Service-Agreement.png';
import CreateAddendum from './icons/Create-Addendum.png';
import StatementWork from './icons/sow.svg';
import AddNewIcons from './icons/add-contact.png';
import GreenCheck from './icons/right-check.svg';
import SaveRedCheck from './icons/save-check.svg';
import NotificationBell from './icons/bell.png';
import ActiveNotificationBell from './icons/orange-bell.png';
import NoContactIcon from './icons/noContact.png';
import PageNotFoundImg from './page-not-found.svg';
import LinkIcons from './icons/link-icon.png';
import CloseArrowIcons from './icons/collapse-close-icon.png';
import MasterCardIcons from './icons/master-card.svg';
import VisaCardIcons from './icons/visa-card.svg';
import DiscoverCardIcons from './icons/discover-card.svg';
import AmercianExpressCardIcons from './icons/american-express-card.svg';
import blackBg from './black-bg.png';
import WhiteLogo from './white-logo.svg';
import AmazonAccount from './amazon-account.svg';
import CompanyDetailsIcon from './company-details.svg';
import LockFinish from './lock-finish.svg';
import PdfDownload from './icons/pdf-download.png';
import VideoCall from './icons/video-call.png';
import InfoIcons from './icons/info-icon.svg';
import RightCircle from './icons/check-circle.svg';
import BilingDetails from './Billing Icon.svg';
import AccountSetupIcon from './Account Setup Complete Icon.svg';
import UserGroupIcon from './icons/user-group.png';
import UserGroupIconActive from './icons/user-groups-active.png';
import ReadBookIcon from './icons/book-read.png';
import ReadBookIconActive from './icons/book-read-active.png';
import LeftArrowIcon from './icons/left-arrow-icon.png';
import RightArrowIcons from './icons/right-arrow-icon.png';
import LightBulb from './icons/light-bulb.png';
import MenuIcon from './icons/menu-icon.svg';
import LogoMobileView from './logo-mobile-view.svg';
import RemoveIcon from './icons/cross-search-icon.png';
import SearchIcon from './icons/search-icons.svg';
import ProductivityTool from './icons/productivity-tool.svg';
import ArrowUp from './icons/arrow-up.png';
import BannerImg from './banner-img.png';
import EditOrangeIcon from './icons/edit-orange-icon.svg';
import FileContract from './icons/file-contract.png';
import Organization from './icons/organization.png';
// import ExchangeIcon from './icons/exchange-icon.png';
import ClockIcon from './icons/clock-icon.svg';
import CopyLinkIcon from './icons/copy-link-orange-icon.png';
import ExternalLink from './icons/external-link-icon.svg';
import HeartMonitorIcon from './icons/heart-monitor-icon.png';
import ArrowUpIcon from './icons/arrow-up-green.png';
import ArrowDownIcon from './icons/arrow-down-red.png';
import RecurringIcon from './icons/recurring-contact.svg';
import ServiceIcon from './icons/service-contact.svg';
import LinkedinIcon from './icons/linkedin-icon.svg';
import InstagramIcon from './icons/instagram-icon.svg';
import TwitterIcon from './icons/twitter-icon.svg';
import SliderHIcon from './icons/slider-h-icon.png';
import ExpandArrowIcon from './icons/expand-arrow-icon.png';
import GreyBannerBg from './grey-bg.jpg';
import OrangeChecked from './icons/orange-solid-checked.svg';
import PlusIcon from './icons/plus-icon.svg';
import MinusIcon from './icons/minus-icon.png';
import NextLogo from './NextLogo.png';
import BackArrowIcon from './icons/back-arrow-back.png';
import DigitalSignature from './Signature.png';
import Advertise from './icons/dsp-advertise.png';
import OrganizationIcon from './icons/organization-icon.png';
import OrganizationActiveIcon from './icons/organization-active-icon.png';
import ExpnadArrowBack from './icons/expand-arrow-back.png';
import CaretUp from './icons/caretUp.png';
import WhiteCaretUp from './icons/whiteCaretUp.png';
import ContractCancel from './contract-voided.svg';
import RedCross from './icons/red-cross.png';
import FileIcon from './icons/file-icon.png';
import CheckFileIcon from './icons/check-file.png';
import EditFileIcon from './icons/edit-file.png';
import SignatureIcon from './icons/signature.png';
import CountDayClock from './icons/count-days-clock.svg';
import SpeedometerActive from './icons/speedometer-icon.png';
import Speedometer from './icons/speedometer-icon-disactive.png';
import OrangeCheckMark from './icons/orange-checkmark.svg';
import WhiteCheckMark from './icons/white-check-icon.svg';
import SquareFbIcon from './icons/square-fb-icon.svg';
import GrayClockIcon from './icons/gray-clock-icon.svg';
// import BillingIcon from './icons/billing-icon.png';
import ArrowRightIcon from './icons/arrow-right-icon.png';
import ArrowRightBlackIcon from './icons/arrow-right-black-icon.png';
import DspOnlyIcon from './icons/dsp-only-icon.png';
import ThadProfileImg from './thad.png';
import CheckboxCheck from './icons/checkmark.svg';
import UpDowGrayArrow from './icons/up-dow-gray-arrow.png';
import BlackCheckMark from './icons/black-checkmark-icon.svg';
import TimesCircle from './icons/times-circle.svg';
import DownloadPdf from './icons/download-icon.svg';
import SecurityLock from './icons/security-lock-icon.png';
import CalendarFontBackArrow from './icons/calendar-back-arrow.png';
import GrayCheckIcon from './icons/gray-check.svg';
import GrayInfoIcon from './icons/gray-info-icon.svg';
import WhiteArrowRight from './icons/white-arrow-right.png';
import OrangeDownloadPdf from './icons/orange-download-pdf.png';
import RedTrashIcon from './icons/red-trash-icon.svg';
import FileCloud from './icon_upload.svg';
import ChatBoxIcon from './icons/chat-box.svg';
import CatalogBox from './icons/catalog-box.png';
import AnnotationGoal from './icons/annotation-goal.png';
import ForwardOrangeIcon from './icons/forward-orange-icon.png';
import PinIcon from './icons/circle-pin.png';
import OrangeChat from './icons/orange-chat-icon.png';
import PinIcons from './icons/pin-icon.png';
import NextActivityLogo from './next-activity-logo.svg';
import RequestPlan from './icons/request-plane.png';
import SortArrowDown from './icons/icons-sort-down.png';
import ProdFavicon from './faviconProd.ico';
import CircleBellIcon from './icons/circle-bell-icon.png';
import HelpIcon from './icons/help.png';
import ContractEmailIcon from './icons/contractEmail.png';
import HelpDeskIcon from './icons/helpdesk.png';
import ExternalLinkFile from './icons/external-link.svg';
import ExternalLinkFileOrange from './icons/external-link-orange.svg';
import CircleCross from './icons/circle-cross.svg';
import HandShake from './icons/hand-shake.png';
import PauseIcon from './icons/pause.svg';
import CloseCircleIcon from './icons/cancel.svg';
import CopyIcon from './icons/copy.svg';
import ViewExternalLink from './icons/view-external-link.svg';
import DeleteIcon from './icons/delete.svg';
import InvoiceIcon from './icons/icon_invoices.svg';
import PartnersIcon from './icons/icon_partners.svg';
import DisabledRecurring from './icons/disabled-recurring.svg';
import InfoRedIcon from './icons/info-red-icon.svg';
import Dollar from './icons/fees.svg';
import helpCircleIcon from './icons/helpCircleIcon.png';
import HomePageIcon from './icons/home-page.png';
import HomePageActiveIcon from './icons/home-page-active.png';
import GreyClockIcon from './icons/grey-clock-icon.svg';
import GraphIconInActive from './icons/graphiconInactive.png';
import GraphIconActive from './icons/graphiconActive.png';
import CurrencyIcon from './icons/fee-icon.svg';
import ArrowRotate from './icons/arrows-rotate-regular.svg';
import EditExternalLinkOrange from './icons/pen-to-square-regular.svg';
import TableColumns from './icons/table-columns.svg';
import Tachometer from './icons/tachometer-light.svg';
import BoxTap from './icons/box-alt-light.svg';
import OrangeInfoIcon from './icons/circle-info-light.svg';
import AuthorizedSC from './icons/authorizedSC.svg';
import UnauthorizedSC from './icons/unauthorizedSC.svg';
import AuthorizedVC from './icons/authorizedVC.svg';
import UnauthorizedVC from './icons/unauthorizedVC.svg';
import NextWhiteLogo from './Next White Logo.svg';
import SponsoredAdPerformance from './Sponsored Ad Performance.svg';
import DSPAdPerformance from './DSP Ad Performance.svg';
import InventoryManagement from './Inventory Management.svg';
import OverallSalesPerformance from './Sales Performance.svg';
import DanielWallsProfileImg from './danielWalls.png';
import BBEStandardLogo from './BBE_Standard_logo.png';
import BBEStandardWideLogo from './BBE_Standard_wide_logo.png';
import monaSerenoImg from './monaSerenoImg.png';
import BrokenFile from './BrokenFile.svg';
import MFAAuthenticationLogo from './Authentication-icon.svg';
import MFAAuthenticationLogo2 from './Authentication-icon2.svg';
import QRCodeImg from './QRcode.svg';

export {
  BannerBg,
  ArrowIcons,
  Logo,
  newLogo,
  DefaultUser,
  SortDown,
  SortUp,
  EditIcons,
  LogOutIcons,
  EditFileIcons,
  CloseIcon,
  EyeIcon,
  smallEyeIcon,
  CloseEyeIcon,
  AttachFile,
  DownloadIcons,
  CopyPasteIcons,
  InstagramIcons,
  TwitterIcons,
  FaceBookIcons,
  LinkeDinIcons,
  TrashIcons,
  SmallCloseIcon,
  AddIcons,
  PinterestIcon,
  RightArrowIcon,
  PlusIcons,
  whiteCross,
  SadIcons,
  SaveIcon,
  CompanyDefaultUser,
  EmailIcon,
  PhoneIcon,
  WhiteSortDown,
  SortDownIcon,
  InfoIcon,
  TelescopeIcon,
  AlarmBellIcon,
  ServiceAgreementIcon,
  CreateAddendum,
  StatementWork,
  AddNewIcons,
  GreenCheck,
  SaveRedCheck,
  NotificationBell,
  ActiveNotificationBell,
  NoContactIcon,
  PageNotFoundImg,
  LinkIcons,
  CloseArrowIcons,
  AmercianExpressCardIcons,
  DiscoverCardIcons,
  MasterCardIcons,
  VisaCardIcons,
  blackBg,
  WhiteLogo,
  AmazonAccount,
  CompanyDetailsIcon,
  LockFinish,
  PdfDownload,
  VideoCall,
  InfoIcons,
  RightCircle,
  BilingDetails,
  AccountSetupIcon,
  UserGroupIcon,
  UserGroupIconActive,
  ReadBookIcon,
  ReadBookIconActive,
  LeftArrowIcon,
  RightArrowIcons,
  LightBulb,
  MenuIcon,
  LogoMobileView,
  RemoveIcon,
  SearchIcon,
  ProductivityTool,
  ArrowUp,
  BannerImg,
  EditOrangeIcon,
  FileContract,
  Organization,
  // ExchangeIcon,
  ClockIcon,
  CopyLinkIcon,
  ExternalLink,
  HeartMonitorIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  RecurringIcon,
  ServiceIcon,
  LinkedinIcon,
  InstagramIcon,
  TwitterIcon,
  SliderHIcon,
  ExpandArrowIcon,
  GreyBannerBg,
  OrangeChecked,
  PlusIcon,
  MinusIcon,
  NextLogo,
  BackArrowIcon,
  DigitalSignature,
  Advertise,
  OrganizationIcon,
  OrganizationActiveIcon,
  ExpnadArrowBack,
  CaretUp,
  WhiteCaretUp,
  ContractCancel,
  RedCross,
  FileIcon,
  CheckFileIcon,
  EditFileIcon,
  SignatureIcon,
  CountDayClock,
  SpeedometerActive,
  Speedometer,
  OrangeCheckMark,
  SquareFbIcon,
  GrayClockIcon,
  // BillingIcon,
  ArrowRightIcon,
  ArrowRightBlackIcon,
  WhiteCheckMark,
  DspOnlyIcon,
  ThadProfileImg,
  CheckboxCheck,
  UpDowGrayArrow,
  BlackCheckMark,
  TimesCircle,
  DownloadPdf,
  SecurityLock,
  CalendarFontBackArrow,
  GrayCheckIcon,
  GrayInfoIcon,
  WhiteArrowRight,
  OrangeDownloadPdf,
  RedTrashIcon,
  FileCloud,
  ChatBoxIcon,
  CatalogBox,
  AnnotationGoal,
  ForwardOrangeIcon,
  PinIcon,
  OrangeChat,
  PinIcons,
  RequestPlan,
  NextActivityLogo,
  SortArrowDown,
  ProdFavicon,
  CircleBellIcon,
  HelpIcon,
  ContractEmailIcon,
  HelpDeskIcon,
  ExternalLinkFile,
  ExternalLinkFileOrange,
  CircleCross,
  HandShake,
  PauseIcon,
  CloseCircleIcon,
  CopyIcon,
  ViewExternalLink,
  DeleteIcon,
  InvoiceIcon,
  PartnersIcon,
  DisabledRecurring,
  InfoRedIcon,
  helpCircleIcon,
  Dollar,
  HomePageIcon,
  HomePageActiveIcon,
  GreyClockIcon,
  GraphIconInActive,
  GraphIconActive,
  CurrencyIcon,
  ArrowRotate,
  EditExternalLinkOrange,
  TableColumns,
  Tachometer,
  BoxTap,
  OrangeInfoIcon,
  AuthorizedSC,
  UnauthorizedSC,
  AuthorizedVC,
  UnauthorizedVC,
  NextWhiteLogo,
  SponsoredAdPerformance,
  DSPAdPerformance,
  InventoryManagement,
  OverallSalesPerformance,
  DanielWallsProfileImg,
  BBEStandardLogo,
  BBEStandardWideLogo,
  monaSerenoImg,
  BrokenFile,
  MFAAuthenticationLogo,
  MFAAuthenticationLogo2,
  QRCodeImg,
};
